import React from "react";
import { Link } from "react-router-dom";
import { Shield, Globe, Clock, ScrollText, Scale } from "lucide-react";
import CleanzaLogo from "@/components/CleanzaLogo";

export default function Footer() {
  return (
    <footer id="contact" className="relative bg-slate-950 text-slate-300 mt-24 overflow-hidden">
      <div className="absolute inset-x-0 top-0 lux-hairline" />
      <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-teal-500/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="mb-6">
              <CleanzaLogo height={88} />
            </div>
            <p className="text-sm text-slate-400 max-w-md leading-relaxed">
              A luxury digital matching platform connecting customers with vetted independent cleaning professionals across the United States.
              CLEANBAZ is not the employer of contractors.
            </p>
            <div className="lux-hairline mt-8 mb-6 max-w-md" />
            <p className="text-xs font-mono text-slate-500">© 2026 CLEANBAZ Inc. — Serving cleaning customers across the United States.</p>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-[0.28em] text-teal-400 mb-5">Compliance</h4>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-tos" to="/legal/service-agreement" className="hover:text-teal-300 transition-colors flex items-center gap-2"><Shield className="w-3.5 h-3.5" />Service Agreement</Link></li>
              <li><Link data-testid="footer-privacy" to="/legal/privacy" className="hover:text-teal-300 transition-colors flex items-center gap-2"><Globe className="w-3.5 h-3.5" />Privacy Protocol (GDPR/CCPA)</Link></li>
              <li><Link data-testid="footer-cancellation" to="/legal/cancellation" className="hover:text-teal-300 transition-colors flex items-center gap-2"><Clock className="w-3.5 h-3.5" />24-Hour Cancellation Policy</Link></li>
              <li><Link data-testid="footer-cleaner-agreement" to="/legal/cleaner-agreement" className="hover:text-teal-300 transition-colors flex items-center gap-2"><ScrollText className="w-3.5 h-3.5" />Cleaner Agreement</Link></li>
              <li><Link data-testid="footer-dispute-policy" to="/legal/dispute-policy" className="hover:text-teal-300 transition-colors flex items-center gap-2"><Scale className="w-3.5 h-3.5" />Dispute &amp; Damage Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-mono uppercase tracking-[0.28em] text-teal-400 mb-5">Get Started</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/signup" className="hover:text-teal-300 transition-colors">Book a cleaning</Link></li>
              <li><Link to="/signup?role=cleaner" className="hover:text-teal-300 transition-colors">Become a cleaner</Link></li>
              <li><Link to="/login" className="hover:text-teal-300 transition-colors">Login</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
